export const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const BACKEND_API_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL;
export const FRONTEND_TO_BACKEND_API_URL =
  process.env.NEXT_PUBLIC_FRONT_END_TO_BACKEND_API_URL || BACKEND_API_URL || '';

// Game URL
export const GAME_URL = `${BACKEND_API_URL}/games`;
export const GAME_URL_FRONT = `${FRONTEND_TO_BACKEND_API_URL}/games`;
export const GAME_SEARCH_URL = `${FRONTEND_TO_BACKEND_API_URL}/games/search`;

// Upcomings URL
export const UPCOMMING_GAMES_URL = `${BACKEND_API_URL}/upcomings`;

// Team URL
export const TEAM_URL = `${BACKEND_API_URL}/teams`;


// Business
export const BUSINESS_CARD_URL = `${BACKEND_API_URL}/business`;

// Blog
export const NEWS_URL = `${BACKEND_API_URL}/news`;
export const NEWS_URL_FRONT = `${FRONTEND_TO_BACKEND_API_URL}/news`;

// Upcomming [event]
export const UPCOMMING_EVENTS_URL = `${BACKEND_API_URL}/events`;

// Features
export const FEATURES_URL = `${BACKEND_API_URL}/features`;

// Partners
export const PARTNERS_URL = `${FRONTEND_TO_BACKEND_API_URL}/partners`;

// Certifications
export const CERTIFICATIONS_URL = `${BACKEND_API_URL}/certifications`;

// Contact us
export const CONTACT_US_URL = `${BACKEND_API_URL}/contact/request`;

// Subscribe
export const SUBSCRIBE_URL = `${BACKEND_API_URL}/subscribe/request`;

//Unsubscribe
export const UNSUBSCRIBE_URL = `${BACKEND_API_URL}/unsubscribe/request`;

// Banners
export const BANNERS_URL = `${BACKEND_API_URL}/banners`;

// Histories
export const HISTORY_URL = `${BACKEND_API_URL}/histories`;

// Notifications
export const NOTIFICATIONS_URL = `${FRONTEND_TO_BACKEND_API_URL}/notifications/card`;

// videos
export const VIDEOS_URL = `${BACKEND_API_URL}/videos`;

// Sitemap
export const SITEMAP_URL = `${BACKEND_API_URL}/sitemap`;
export const PAGE_SITEMAP_URL = `${BACKEND_API_URL}/sitemap/page_sitemap`;
export const POSTS_SITEMAP_URL = `${BACKEND_API_URL}/sitemap/posts_sitemap`;
export const GAMES_SITEMAP_URL = `${BACKEND_API_URL}/sitemap/games_sitemap`;

// QUIZ
export const QUIZ_GET_ID = `${BACKEND_API_URL}/quizzes/get-active`;
export const QUIZ_ADD_PARTICIPANT = `${BACKEND_API_URL}/quizParticipants/create`;
export const QUIZ_UPDATE_PARTICIPANT = `${BACKEND_API_URL}/quizParticipants/update`;

export const URLS = {
  GAME_URL,
  GAME_URL_FRONT,
  NEWS_URL,
  NEWS_URL_FRONT,
  TEAM_URL,
  HISTORY_URL,
  BANNERS_URL,
  SITEMAP_URL,
  PARTNERS_URL,
  FEATURES_URL,
  CONTACT_US_URL,
  GAME_SEARCH_URL,
  PAGE_SITEMAP_URL,
  NOTIFICATIONS_URL,
  BUSINESS_CARD_URL,
  POSTS_SITEMAP_URL,
  GAMES_SITEMAP_URL,
  CERTIFICATIONS_URL,
  UPCOMMING_GAMES_URL,
  UPCOMMING_EVENTS_URL,
  VIDEOS_URL,
};
